import React from 'react'

import { Helmet } from 'react-helmet'

import Rea from '../../components/rea'
import ProcessoDuplo from '../../components/processo-duplo'
import Processo from '../../components/processo'
import ProcessoReversoDuplo from '../../components/processo-reverso-duplo'
import ReaProcessoExtraJudicial from '../../components/rea-processo-extra-judicial'
import './old-ara-familiar.css'

const OldAraFamiliar = (props) => {
  return (
    <div className="old-ara-familiar-container1">
      <Helmet>
        <title>Old-Ara-Familiar - Adv. Wanderson H Cavalari - Cuiabá</title>
        <meta
          name="description"
          content="Advogado em Cuiabá a mais de 10 anos, defendendo seus direitos com expertise e comprometimento."
        />
        <meta
          property="og:title"
          content="Old-Ara-Familiar - Adv. Wanderson H Cavalari - Cuiabá"
        />
        <meta
          property="og:description"
          content="Advogado em Cuiabá a mais de 10 anos, defendendo seus direitos com expertise e comprometimento."
        />
      </Helmet>
      <Rea
        titulo="Família"
        imageSrc="https://images.unsplash.com/photo-1602274627509-c6b4002bbd5f?ixid=M3w5MTMyMXwwfDF8c2VhcmNofDc1fHxmYW1pbGlhfGVufDB8fHx8MTcxMTc1MzQ2Nnww&amp;ixlib=rb-4.0.3&amp;h=1500"
        descricao="A área da família na advocacia lida com questões legais relacionadas a relações familiares, como casamento, divórcio, guarda dos filhos e paternidade. É uma prática que requer sensibilidade, pois afeta diretamente a vida pessoal dos envolvidos."
        rootClassName="rearoot-class-name"
      >
        <div className="old-ara-familiar-container2">
          <div className="old-ara-familiar-frame86">
            <ProcessoDuplo
              text="Desde a promulgação da Emenda Constitucional nº 66, não se reconhecem mais ações de separação judicial no ordenamento jurídico brasileiro. A partir dessa alteração legislativa, quando as partes optam pela dissolução do vínculo matrimonial, têm duas opções para regularizar sua situação: por meio do divórcio ou através da separação de corpos."
              text1="Em certos casos, a intervenção judicial se torna necessária para efetuar a separação entre os cônjuges, geralmente com o objetivo de garantir a proteção da integridade física e mental das partes envolvidas."
              title="Ações de\xA0Separação Judicial"
              title1="Ações de\xA0Separação de Corpos"
              imageSrc="https://images.unsplash.com/photo-1593115057322-e94b77572f20?ixid=M3w5MTMyMXwwfDF8c2VhcmNofDN8fGp1c3RpY2V8ZW58MHx8fHwxNzExNzQ0MjEzfDA&amp;ixlib=rb-4.0.3&amp;h=300"
              rootClassName="processo-duploroot-class-name1"
            ></ProcessoDuplo>
            <Processo
              text="A união estável é uma relação afetiva que, diferentemente do casamento, não requer formalidades específicas. Por essa razão, é considerada uma situação de fato. Para que seja reconhecida como tal, a união estável deve apresentar uma série de características definidoras, as quais acarretam diversas consequências jurídicas.  Embora o casal opte por viver junto sem o vínculo matrimonial, é altamente recomendável a regulamentação dessa convivência por meio de um contrato de convivência e/ou escritura de união estável. Esses instrumentos permitem que os envolvidos estabeleçam diversos aspectos, incluindo a data de início da relação e o regime de bens desejado.  No caso de término da relação, seja por separação ou óbito, torna-se necessário ingressar com uma ação judicial para que a união estável seja oficialmente reconhecida e, consequentemente, os direitos decorrentes dela sejam assegurados."
              title="Ações Relativas à\xA0União Estável"
              imageSrc="https://images.unsplash.com/photo-1534469589579-86bd01bc003a?ixid=M3w5MTMyMXwwfDF8c2VhcmNofDZ8fG1hcmJsZSUyMGNvbHVtbnxlbnwwfHx8fDE3MDczMjMzNzB8MA&amp;ixlib=rb-4.0.3&amp;h=300"
              rootClassName="processoroot-class-name11"
            ></Processo>
            <ProcessoReversoDuplo
              imageSrc="https://images.unsplash.com/photo-1632082064140-7da23f93cf17?ixid=M3w5MTMyMXwwfDF8c2VhcmNofDQ0fHxmb29kJTIwc3VwZXJtYXJrZXR8ZW58MHx8fHwxNzExNzQ1NzM0fDA&amp;ixlib=rb-4.0.3&amp;h=300"
              textoSegundo="O princípio fundamental considerado reside na avaliação da extensão das necessidades da parte requerente e da capacidade da parte fornecedora em prover pensão. Na ausência de um acordo mútuo, o juiz invariavelmente aplicará o princípio do binômio 'possibilidade versus necessidade'."
              rootClassName="processo-reverso-duploroot-class-name"
              textoPrimeiro="O direito à pensão alimentícia geralmente surge da incapacidade de uma pessoa de sustentar a si mesma, seja por ser menor de idade, idosa, ou inválida, e tem a possibilidade de recorrer a um indivíduo com o qual mantém laço, seja consanguíneo ou matrimonial.  O dever de prover alimentos é estabelecido por lei, e aquele que for considerado devedor é obrigado a cumprir essa obrigação, sujeito até mesmo a medidas coercitivas como a prisão."
              tituloSegundo="Valor da\xA0Pensão"
              tituloPrimeiro="Ações Sobre\xA0Pensão Alimentícia"
            ></ProcessoReversoDuplo>
            <ProcessoDuplo
              text="A interação entre pais e filhos é crucial para o desenvolvimento saudável das crianças. Quando não vivem juntos, é importante garantir visitas regulares do genitor não guardião para manter esse vínculo. As visitas são períodos de interação entre pais e filhos, facilitando essa conexão mesmo em lares separados."
              text1=" É cada vez mais comum pais separados, solteiros ou recasados. A guarda compartilhada, onde ambos os pais dividem responsabilidades na criação dos filhos, vem ganhando destaque. As decisões sobre os filhos são tomadas em consenso, visando o bem-estar deles. Não implica necessariamente divisão equitativa do tempo, mas ambos os pais mantêm convivência. Quando há disputa pela guarda exclusiva, o Judiciário decide com base no melhor interesse das crianças, garantindo uma decisão justa e equitativa."
              title="Ações de\xA0Regulamentação de Visitas"
              title1="Ações Sobre\xA0Guarda de Menores"
              imageSrc="https://images.unsplash.com/photo-1641667157296-37312a952d0d?ixid=M3w5MTMyMXwwfDF8c2VhcmNofDU3fHxraWQlMjBzaXR0aW5nfGVufDB8fHx8MTcxMTc0NjM0MXww&amp;ixlib=rb-4.0.3&amp;h=300"
              rootClassName="processo-duploroot-class-name"
            ></ProcessoDuplo>
          </div>
          <div className="old-ara-familiar-container3">
            <span className="Head old-ara-familiar-text10">Extrajudicial</span>
          </div>
          <ReaProcessoExtraJudicial titulo="Acompanhamento e Realização de Testamentos">
            <span className="old-ara-familiar-text11 Content">
              <span>
                O testamento é um instrumento crucial no Planejamento
                Sucessório, permitindo que os bens sejam distribuídos de acordo
                com a vontade expressa do titular do patrimônio. Embora a lei
                preveja uma sucessão de bens em casos de ausência de testamento,
                essa disposição nem sempre reflete os desejos do falecido.
                Portanto, a elaboração de um testamento é essencial para
                assegurar que os ativos sejam distribuídos conforme a última
                vontade do indivíduo.
              </span>
              <br className="Content"></br>
              <br className="Content"></br>
              <span>
                Existem diversas formas de proceder com um testamento, sendo a
                mais comum a forma pública. Nosso serviço abrange desde a
                orientação inicial até a redação da minuta que melhor atenda aos
                interesses do cliente, garantindo um processo eficiente e
                alinhado com seus desejos. Além do testamento público, também
                são considerados o testamento particular, codicilos e outros
                atos jurídicos que viabilizam a concretização da última vontade
                do testador.
              </span>
            </span>
          </ReaProcessoExtraJudicial>
          <ReaProcessoExtraJudicial titulo="Pacto Antenupcial">
            <span className="old-ara-familiar-text16 Content">
              A escolha do regime matrimonial é essencial para os noivos,
              permitindo que optem pelo modelo que melhor se adeque às suas
              necessidades. É importante formalizar essa decisão através de um
              pacto antenupcial antes do casamento, para evitar a aplicação
              automática do regime da comunhão parcial de bens. O pacto
              antenupcial oferece flexibilidade aos cônjuges, permitindo a
              personalização das disposições relativas ao regime de bens de
              acordo com suas preferências.
            </span>
          </ReaProcessoExtraJudicial>
          <ReaProcessoExtraJudicial titulo="Escritura e Contratos de União Estável">
            <span className="old-ara-familiar-text17 Content">
              Com total discrição e profissionalismo, nossa equipe redige
              minutas personalizadas em nosso escritório, atendendo aos
              interesses específicos de cada cliente. Essas minutas podem ser
              elaboradas para fins particulares ou para formalização por meio de
              Escritura Pública. No caso desta última modalidade, oferecemos um
              serviço completo que inclui encaminhamento ao cartório e
              acompanhamento integral do processo. Além disso, proporcionamos a
              comodidade aos clientes de realizarem a assinatura do documento
              diretamente em nosso escritório, garantindo praticidade e
              segurança em todo o procedimento.
            </span>
          </ReaProcessoExtraJudicial>
          <ReaProcessoExtraJudicial titulo="Reconhecimento de Paternidade">
            <span className="old-ara-familiar-text18 Content">
              <span>
                O reconhecimento da paternidade pode ser uma decisão espontânea,
                dispensando a necessidade de ingressar com uma ação de
                investigação de paternidade. Nesse contexto, a vontade do
                progenitor pode ser formalizada por meio de escritura pública ou
                documento particular a ser devidamente arquivado no cartório
                competente. Em ambos os casos, é fundamental que exista uma
                certeza inequívoca quanto à manifestação da vontade do
                declarante.
              </span>
              <br></br>
              <br></br>
              <span>
                Ademais, é importante ressaltar que o reconhecimento da filiação
                também pode ser expresso por meio de testamento, conferindo mais
                uma via legal para a efetivação desse ato.
              </span>
              <br></br>
              <br></br>
              <span>
                É crucial entender que uma vez efetuado, o reconhecimento da
                paternidade é irrevogável, acarretando na averbação do nome do
                genitor no registro de nascimento do filho, sem qualquer
                observação adicional.
              </span>
              <br></br>
              <br></br>
              <span>
                Essas medidas visam assegurar a estabilidade e a segurança
                jurídica nas relações familiares, promovendo o pleno
                reconhecimento do vínculo paterno-filial de forma clara e
                definitiva.
              </span>
            </span>
          </ReaProcessoExtraJudicial>
          <ReaProcessoExtraJudicial titulo="Divórcios em Tabelionato">
            <span className="old-ara-familiar-text29 Content">
              <span>
                Oferecemos serviços de redação de minutas personalizadas de
                acordo com as necessidades e interesses específicos de nossos
                clientes. Nossa equipe se encarrega de encaminhar toda a
                documentação necessária ao cartório e acompanha de perto todo o
                processo. Além disso, proporcionamos a conveniência de assinar
                qualquer escritura de forma discreta e segura em nosso
                escritório.
              </span>
              <br></br>
              <br></br>
              <span>
                É importante ressaltar que o divórcio em Tabelionato é uma opção
                viável para casais que não possuem filhos menores incapazes e
                que tenham chegado a um acordo mútuo. Nossa equipe está
                preparada para orientar e auxiliar durante todo o processo,
                garantindo uma resolução eficiente e satisfatória para ambas as
                partes.
              </span>
              <br></br>
            </span>
          </ReaProcessoExtraJudicial>
          <ReaProcessoExtraJudicial titulo="Inventário e Partilha em Tabelionato">
            <span className="old-ara-familiar-text35 Content">
              O inventário pode ser conduzido em um tabelionato desde que não
              haja testamento envolvido e a participação de menores ou
              incapazes. Nessas situações específicas, a intervenção judicial se
              torna necessária. Nosso escritório oferece orientação, redação e
              acompanhamento em inventários e partilhas, inclusive quando são
              conduzidos em tabelionato. Com nossa expertise jurídica,
              garantimos um processo eficiente e tranquilo, cuidando de todos os
              aspectos legais envolvidos.
            </span>
          </ReaProcessoExtraJudicial>
        </div>
      </Rea>
      <a
        href="https://play.teleporthq.io/signup"
        className="old-ara-familiar-link"
      >
        <div
          aria-label="Sign up to TeleportHQ"
          className="old-ara-familiar-container4"
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 19 21"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="old-ara-familiar-icon1"
          >
            <path
              d="M9.1017 4.64355H2.17867C0.711684 4.64355 -0.477539 5.79975 -0.477539 7.22599V13.9567C-0.477539 15.3829 0.711684 16.5391 2.17867 16.5391H9.1017C10.5687 16.5391 11.7579 15.3829 11.7579 13.9567V7.22599C11.7579 5.79975 10.5687 4.64355 9.1017 4.64355Z"
              fill="#B23ADE"
            ></path>
            <path
              d="M10.9733 12.7878C14.4208 12.7878 17.2156 10.0706 17.2156 6.71886C17.2156 3.3671 14.4208 0.649963 10.9733 0.649963C7.52573 0.649963 4.73096 3.3671 4.73096 6.71886C4.73096 10.0706 7.52573 12.7878 10.9733 12.7878Z"
              fill="#FF5C5C"
            ></path>
            <path
              d="M17.7373 13.3654C19.1497 14.1588 19.1497 15.4634 17.7373 16.2493L10.0865 20.5387C8.67402 21.332 7.51855 20.6836 7.51855 19.0968V10.5141C7.51855 8.92916 8.67402 8.2807 10.0865 9.07221L17.7373 13.3654Z"
              fill="#2874DE"
            ></path>
          </svg>
          <span className="old-ara-familiar-text36">Built in TeleportHQ</span>
        </div>
      </a>
    </div>
  )
}

export default OldAraFamiliar
